/* One Cask at a Time: next-day delivery promise (Oct 2026). The bag drawer's
   "Order within ... and it ships today" line (assets/cart-extras.js). Same file as the
   design canvas's ~/ocaat/design/web-calm/delivery-promise.js, plus the holiday list.


   Rules (Alex, 12 Oct 2026), checked against 491 delivered Shopify fulfilments:
   - Boxworx dispatches Monday to Friday. Orders placed before 2pm UK time go out
     the same day; later orders go out the next working day.
   - Royal Mail Tracked 24 delivers the day after dispatch, Monday to Saturday, so a
     Friday dispatch arrives Saturday (75 of 94 Friday dispatches did).
   - No dispatch or delivery on England and Wales bank holidays, nor on 25 or 26
     December; the date rolls on to the next open day.

   promise(now, holidays) -> { dispatch, deliver, cutoff, minutesLeft, within24h }
   dates are 'YYYY-MM-DD' strings in UK time; cutoff is the UK wall-clock 2pm of the
   dispatch day, as minutes from now. Pure: no DOM, so the canvas, the theme and
   node tests all run the same code. */
(function (root) {
  var CUTOFF_MIN = 14 * 60;
  var DAY = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var MONTH = ['January', 'February', 'March', 'April', 'May', 'June', 'July',
               'August', 'September', 'October', 'November', 'December'];

  // UK wall-clock parts of an instant
  function ukParts(now) {
    var f = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/London', year: 'numeric', month: '2-digit',
      day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
    var p = {};
    f.formatToParts(now).forEach(function (x) { p[x.type] = x.value; });
    return { date: p.year + '-' + p.month + '-' + p.day, minute: (+p.hour) * 60 + (+p.minute) };
  }
  // civil-date arithmetic on 'YYYY-MM-DD' (UTC noon avoids any DST edge)
  function addDays(d, n) {
    var t = new Date(d + 'T12:00:00Z');
    t.setUTCDate(t.getUTCDate() + n);
    return t.toISOString().slice(0, 10);
  }
  function weekday(d) { return new Date(d + 'T12:00:00Z').getUTCDay(); }
  function daysBetween(a, b) { return Math.round((new Date(b + 'T12:00:00Z') - new Date(a + 'T12:00:00Z')) / 864e5); }

  function promise(now, holidays) {
    var hol = {};
    (holidays || []).forEach(function (d) { hol[d] = true; });
    // 25 and 26 December are always off, whatever day they fall on: when Boxing Day is a
    // Saturday the bank holiday moves to Monday, but Royal Mail still does not deliver.
    var closed = function (d) { var md = d.slice(5); return hol[d] || md === '12-25' || md === '12-26'; };
    var dispatchDay = function (d) { var w = weekday(d); return w >= 1 && w <= 5 && !closed(d); };
    var deliveryDay = function (d) { var w = weekday(d); return w >= 1 && w <= 6 && !closed(d); };
    var uk = ukParts(now);
    var dispatch = uk.date;
    if (!(dispatchDay(dispatch) && uk.minute < CUTOFF_MIN)) {
      dispatch = addDays(dispatch, 1);
      while (!dispatchDay(dispatch)) dispatch = addDays(dispatch, 1);
    }
    var deliver = addDays(dispatch, 1);
    while (!deliveryDay(deliver)) deliver = addDays(deliver, 1);
    var minutesLeft = daysBetween(uk.date, dispatch) * 1440 + CUTOFF_MIN - uk.minute;
    return { today: uk.date, dispatch: dispatch, deliver: deliver, minutesLeft: minutesLeft,
             within24h: minutesLeft <= 1440 };
  }

  // "Saturday 17 October", or "tomorrow" when it is the next calendar day
  function dayName(d, today) {
    if (daysBetween(today, d) === 1) return 'tomorrow';
    var t = new Date(d + 'T12:00:00Z');
    return DAY[t.getUTCDay()] + ' ' + t.getUTCDate() + ' ' + MONTH[t.getUTCMonth()];
  }
  function longDate(d) {
    var t = new Date(d + 'T12:00:00Z');
    return DAY[t.getUTCDay()] + ' ' + t.getUTCDate() + ' ' + MONTH[t.getUTCMonth()];
  }
  // "2 hrs 40 mins", "40 mins", "21 hrs"
  function countdown(min) {
    var h = Math.floor(min / 60), m = min % 60;
    var hs = h ? h + (h === 1 ? ' hr' : ' hrs') : '';
    var ms = m ? m + (m === 1 ? ' min' : ' mins') : '';
    if (h >= 10) return hs;                 // minutes stop mattering past ten hours
    return [hs, ms].filter(Boolean).join(' ') || '1 min';
  }
  // the words for the bag. firm: "for delivery"; soft: "ships today, usually with you"
  function words(p, soft) {
    var when = dayName(p.deliver, p.today);
    var by = p.within24h
      ? 'Order within ' + countdown(p.minutesLeft)
      : 'Order by 2pm ' + DAY[weekday(p.dispatch)];
    var shipsWhen = p.dispatch === p.today ? 'today' : (daysBetween(p.today, p.dispatch) === 1 ? 'tomorrow' : DAY[weekday(p.dispatch)]);
    if (soft) {
      // more than a day to the cut-off: "Order now", not "Order by 2pm Monday ... ships Monday"
      return { head: (p.within24h ? by : 'Order now') + ' and it ships ' + shipsWhen,
               sub: 'Usually with you ' + (when === 'tomorrow' ? 'tomorrow, ' + longDate(p.deliver) : when) + ', by Royal Mail Tracked 24' };
    }
    return { head: by + ' for delivery ' + when,
             sub: (when === 'tomorrow' ? longDate(p.deliver) + ', ' : '') + 'Royal Mail Tracked 24, dispatched ' + shipsWhen };
  }

  // England and Wales bank holidays from GOV.UK (www.gov.uk/bank-holidays.json),
  // fetched 12 Oct 2026; the list runs to the end of 2028, so refresh it before then.
  var HOLIDAYS = ["2026-01-01", "2026-04-03", "2026-04-06", "2026-05-04", "2026-05-25", "2026-08-31", "2026-12-25", "2026-12-28", "2027-01-01", "2027-03-26", "2027-03-29", "2027-05-03", "2027-05-31", "2027-08-30", "2027-12-27", "2027-12-28", "2028-01-03", "2028-04-14", "2028-04-17", "2028-05-01", "2028-05-29", "2028-08-28", "2028-12-25", "2028-12-26"];

  var api = { promise: promise, words: words, countdown: countdown, longDate: longDate, HOLIDAYS: HOLIDAYS };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.OcaatDelivery = api;
})(this);
